import { OxygenForm } from '../elements/oxygenForm.js';
import { fromEvent } from 'rxjs';

// const oxygenForm = document.querySelector('form[is="oxygen-form"]');
// const clickObservable = fromEvent(oxygenForm, 'click');

// clickObservable.subscribe(event => {
//     console.log('Oxygen form clicked!', event);
// });

// Optional: Extend more HTML tags in the future
// Example: class CustomButton extends HTMLElement { ... }
// customElements.define('custom-button', CustomButton);

// Function to inject the custom element into an iframe
export function injectIntoIframe(iframe) {
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
    
    const script = iframeDoc.createElement('script');
    script.type = 'module';
    script.textContent = `
        import { OxygenForm } from '${new URL('./BotServices/elements/oxygenForm.js', document.baseURI)}';
    `;
    iframeDoc.body.appendChild(script);
}

// Function to inject the custom element into a web component
export function injectIntoWebComponent(component) {
    const shadowRoot = component.shadowRoot || component.attachShadow({ mode: 'open' });

    const form = document.createElement('oxygen-form');
    shadowRoot.appendChild(form);
}
